import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClipboardService } from 'ngx-clipboard';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { BuddyUrlSearch, LinkUrl } from 'src/app/models/buddy';
import { BuddyService } from 'src/app/services/buddy.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-mobile-link',
  templateUrl: './mobile-link.component.html',
  styleUrls: ['./mobile-link.component.css']
})
export class MobileLinkComponent implements OnInit {

  constructor(
    private buddyService: BuddyService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private clipboardService: ClipboardService
  ) { 
    
    this.route.queryParams.subscribe(params => {
      if(params['tab']) {
        this.tab = params['tab']
      }
    })
    if(!this.commonService.getIsMobile()) {
      if(this.tab == 'add') {
        this.router.navigate(['/link/product/add'])
      } else {
        this.router.navigate(['/link/list'])
      }
    }
  }

  list: LinkUrl[] = new Array()
  addedList: LinkUrl[] = new Array()
  linkUrl: string
  tab: string = 'add'
  ngOnInit(): void {
    this.search.searchType = ''
    this.search.urlType = ''
    this.getLinkList()
  }
  tabSelect(tab: string) {
    this.tab = tab
    if(this.tab == 'add') {
      this.addedList = new Array()
    } else {
      this.getLinkList()
    }
  }
  linkDetail(item: LinkUrl) {
    if(!item.isOpen) {
      this.list.forEach(link => link.isOpen = false)
      item.isOpen = true
    } else [
      item.isOpen = false
    ]
  }
  search = new BuddyUrlSearch()
  getLinkList() {
    this.search.fromDate = null
    this.search.toDate = null
    this.spinner.show();
    this.buddyService.getLinkList(this.search).subscribe(res => {
      this.spinner.hide()
      this.list = res.data.content
    })
  }

  addLinkUrl() : any {
    if(this.linkUrl) {
      this.linkUrl = this.linkUrl.trim()
    }
    if(!this.linkUrl || !this.linkUrl.startsWith('https://')) {
      this.toastr.error('URL정보가 정확하지 않습니다')
      return
    }
    if(!this.linkUrl.startsWith('https://oasis.co.kr')
      && !this.linkUrl.startsWith('https://www.oasis.co.kr')
        && !this.linkUrl.startsWith('https://m.oasis.co.kr')
    ) {
      this.toastr.error('오아시스마켓 URL정보를 입력해 주세요')
      return
    }
    this.spinner.show()
    this.buddyService.addLinkUrl(this.linkUrl, null).subscribe(res => {
      this.linkUrl = null
      this.spinner.hide()
      if(res.resultCode == '8888') {
        let link: LinkUrl = res.data
        if(this.addedList.filter(aa => aa.urlKey == link.urlKey).length == 0) {
          this.addedList.push(link)
        }
      } else {
        alert(res.message)
      }
    })
  }
  removeUrl(item: LinkUrl) {
    alert("준비중")
  }
  copyUrl(item: LinkUrl) {
    this.clipboardService.copy(item.buddyUrl)
    this.toastr.success('URL이 복사되었습니다.')
  }
}
